export default class FaqByCategory {
    constructor($el) {
        this.$el = $el;

        this.$categoryButtons = this.$el.querySelectorAll('[data-faq-list-by-category-toggle]');
        this.$questionContainers = this.$el.querySelectorAll('[data-faq-list-by-category-container]');

        this.activeCategory = null;
        this.activeCategoryButton = null;

        this.listenForToggle = this.listenForToggle.bind(this);

        let index = 0;
        this.$categoryButtons.forEach(($button) => {
            $button.addEventListener('click', this.listenForToggle);

            if (index !== 0) {
                return;
            }

            index += 1;
            this.activeCategory = $button.dataset.faqListByCategoryToggle;
            this.activeCategoryButton = $button;
        });

        this.activeQuestionContainer = null;

        this.$questionContainers.forEach(($container) => {
             const containerId = $container.dataset.faqListByCategoryContainer;

             if (this.activeCategory !== containerId) {
                 $container.classList.add('no-display');
             } else {
                 this.activeQuestionContainer = $container;
             }
        });
    }

    listenForToggle(e) {
        e.preventDefault();

        this.activeCategory = e.target.dataset.faqListByCategoryToggle;

        this.activeCategoryButton.classList.add('button--outline');
        this.activeCategoryButton = e.target;
        this.activeCategoryButton.classList.remove('button--outline');

        this.activeQuestionContainer.classList.add('no-display');
        this.activeQuestionContainer = document.querySelector(`[data-faq-list-by-category-container="${this.activeCategory}"]`);
        this.activeQuestionContainer.classList.remove('no-display');
    }
}